import React from 'react';
import { colors } from '../theme';
import { formatDisplayDate, formatLocal } from './utils';
import NameSuggest from './NameSuggest';

export default function UidHeader({ tenant, uid, customName, firstSeen, lastSeen, scansCount, onNameSaved }) {
  const displayName = customName?.trim() || uid;
  const age = firstSeen ? formatDisplayDate(firstSeen) : 'Unknown';
  const lastSeenLabel = lastSeen ? formatLocal(lastSeen) : 'Unknown';

  return (
    <header style={headerStyle}>
      <div style={titleBlockStyle}>
        <h1 style={titleStyle}>{displayName}</h1>
        {customName && (
          <p style={subtitleStyle}>UID: {uid}</p>
        )}
        <dl style={metaListStyle}>
          <div style={metaItemStyle}>
            <dt style={metaTermStyle}>First seen</dt>
            <dd style={metaValueStyle} title={firstSeen || ''}>{age}</dd>
          </div>
          <div style={metaItemStyle}>
            <dt style={metaTermStyle}>Last seen</dt>
            <dd style={metaValueStyle} title={lastSeen || ''}>{lastSeenLabel}</dd>
          </div>
          <div style={metaItemStyle}>
            <dt style={metaTermStyle}>Scans</dt>
            <dd style={metaValueStyle}>{scansCount?.toLocaleString?.() ?? scansCount ?? 0}</dd>
          </div>
        </dl>
      </div>

      <div style={namingCardStyle}>
        <NameSuggest
          tenant={tenant}
          uid={uid}
          initialName={customName}
          onSaved={onNameSaved}
        />
      </div>
    </header>
  );
}

const headerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
};

const titleBlockStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.6rem',
};

const titleStyle = {
  margin: 0,
  fontSize: '2rem',
  color: colors.text,
};

const subtitleStyle = {
  margin: 0,
  fontSize: '0.95rem',
  color: colors.muted,
};

const metaListStyle = {
  display: 'flex',
  gap: '1.5rem',
  flexWrap: 'wrap',
  margin: 0,
};

const metaItemStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.2rem',
};

const metaTermStyle = {
  fontSize: '0.75rem',
  color: colors.muted,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  margin: 0,
};

const metaValueStyle = {
  fontSize: '1.05rem',
  fontWeight: 600,
  margin: 0,
};

const namingCardStyle = {
  backgroundColor: 'rgba(70,187,137,0.1)',
  borderRadius: '16px',
  padding: '1rem 1.25rem',
  border: '1px solid rgba(70,187,137,0.25)',
  maxWidth: '420px',
};
